<template>
  <div :class="$style.empty" :style="{ 'margin-top': top + 'rem' }">
    <p :class="[$style.icon, $style['icon_' + name]]" />
    <p :class="$style.text">{{ text }}</p>
    <slot></slot>
  </div>
</template>
<script>
export default {
  name: "tipIcon",
  props: {
    //名称
    name: String,
    //提示文字
    text: {
      type: String,
      default: "暂无数据"
    },
    top: {
      type: String,
      default: "2"
    }
  }
};
</script>
<style lang="less" module>
.empty {
  .flex-col;
  .flex-center;
}
.icon {
  .size(2.5rem);
  background: url("../assets/Images/empty-tip.png") no-repeat;
  background-size: 200% 100%;
  &_order {
    background-position: 0% 0%;
  }
  &_ask {
    background-position: 100% 0%;
  }
}
.text {
  color: #48d5af;
  font-size: 0.3rem;
  margin: 0.4rem 0 0.6rem 0;
}
</style>
